import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getUserDetails } from "../apis/apis";
import CustomSnackbar from "../components/Toast/CustomSnackbar";
import CardLayout from "../components/layout/CardLayout";
import NumericStepper from "../components/NumericStepper";

function KycConfirmation() {
  const history = useHistory();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    // Fetch initial user details or perform any other necessary setup
  }, []);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const submit = async () => {
    try {
      const { data, status, description } = await getUserDetails();
      if (status) {
        if (data.mcaStatus === 0) {
          history.replace("/user/investmet-method");
        } else {
          history.replace("/user/home");
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CardLayout>
      <div className="container mt-5">
        <NumericStepper />
        <h3 className="title-md text-center">Verified</h3>
        <p className="title-sm text-center mb-5">Your identity has been verified</p>
        <div className="d-flex justify-content-center mb-5">
          <img
            src={"/img/undraw_agree_re_hor9.svg"}
            alt="verified"
            width={"500px"}
          />
        </div>
      </div>
      <div className="d-flex justify-content-center mb-5">
        <button className="color-btn mx-auto" onClick={submit}>
          PROCEED
        </button>
      </div>
      
      <CustomSnackbar
        open={openSnackbar}
        severity="error"
        duration={2000}
        text="Pan Card Details are not saved"
        handleClose={handleSnackbarClose}
      />
    </CardLayout>
  );
}

export default KycConfirmation;
